export default "__VITE_ASSET__0da4d9ee__"